import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    label: {
      display: 'flex',
      gap: theme.spacing(0.5),
    },
    divider: {
      width: '100%',
      margin: theme.spacing(1, 0),
    },
    accordionComponent: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    selectionIcons: {
      display: 'inline-flex',
      gap: theme.spacing(0.25),
      margin: theme.spacing(0, 1),
    },
    hasChanged: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.primary.main,
      fontSize: '0.8em',
      margin: theme.spacing(0, 0.5),
    },
  };
};
